// src/apiConfig.js — API base URL for cached_fusion_scan.php, tickers, gex, etc.
//
// Order of resolution:
// 1) REACT_APP_API_BASE_URL — full base URL, no trailing slash (e.g. https://fusion.opcioguru.com)
// 2) REACT_APP_API_ENV — key below: localphp | localpython | docker | og
// 3) In the browser: fusion.opcioguru.com -> production (og)
// 4) localhost / 127.0.0.1 -> localphp (XAMPP / PHP on 8080)
// 5) Any other host (preview, staging) -> production API so builds work without env

const API_ENDPOINTS = {
  localphp: 'http://localhost:8080',
  localpython: 'http://localhost:8000',
  docker: 'http://localhost:8070',
  og: 'https://fusion.opcioguru.com',
};

const DEFAULT_LOCAL = 'localphp';

function isProductionHostname() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'fusion.opcioguru.com';
}

function isLocalDevHostname() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

export const getApiBaseUrl = () => {
  const baseOverride = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (baseOverride) {
    return baseOverride.replace(/\/$/, '');
  }

  const envKey = (process.env.REACT_APP_API_ENV || '').trim();
  if (envKey && API_ENDPOINTS[envKey]) {
    return API_ENDPOINTS[envKey];
  }

  if (typeof window !== 'undefined') {
    if (isProductionHostname()) {
      return API_ENDPOINTS.og;
    }
    if (isLocalDevHostname()) {
      return API_ENDPOINTS[DEFAULT_LOCAL] || API_ENDPOINTS.localphp;
    }
  }

  // Staging / file preview / unknown host: call production API (same as live site)
  return API_ENDPOINTS.og;
};

export const getApiEnvironmentLabel = () => {
  if ((process.env.REACT_APP_API_BASE_URL || '').trim()) return 'REACT_APP_API_BASE_URL';
  if ((process.env.REACT_APP_API_ENV || '').trim()) return `REACT_APP_API_ENV=${process.env.REACT_APP_API_ENV}`;
  if (typeof window !== 'undefined') {
    if (isProductionHostname()) return 'og (hostname)';
    if (isLocalDevHostname()) return `${DEFAULT_LOCAL} (hostname)`;
  }
  return 'og (fallback)';
};

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.log(`[apiConfig] ${getApiEnvironmentLabel()} -> ${getApiBaseUrl()}`);
}
